var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".7vw",
    height: ".7vw",
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 11.6797H13.7487",
    stroke: "#4DB6AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 15.3516H11.347",
    stroke: "#4DB6AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0454 2.33594H9.16536C8.2487 2.33594 7.33203 2.33594 7.33203 4.16927C7.33203 6.0026 8.2487 6.0026 9.16536 6.0026H12.832C14.6654 6.0026 14.6654 5.08594 14.6654 4.16927C14.6654 2.33594 13.7487 2.33594 12.832 2.33594",
    stroke: "#4DB6AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.66917C2.75 5.48917 4.28083 4.3525 7.33333 4.1875",
    stroke: "#4DB6AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 4C17.9692 4.165 19.5 5.2925 19.5 9.48167V14.9817C19.5 18.6483 18.5833 20.4817 14 20.4817H8.5C3.91667 20.4817 3 18.6483 3 14.9817V13.0658",
    stroke: "#4DB6AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIcon);
export default __webpack_public_path__ + "static/media/catalogIcon.dbb5d6a060414e5a79a809f51cded910.svg";
export { ForwardRef as ReactComponent };